interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages = Array.from({ length: totalPages }, (_, index) => index + 1);

  return (
    <nav className="flex items-center justify-center gap-1.5 flex-wrap" aria-label="分页导航">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, page - 1))}
        disabled={page === 1}
        className="w-9 h-9 flex items-center justify-center rounded-md border border-background-300 text-foreground-700 disabled:opacity-40 disabled:cursor-not-allowed hover:bg-background-100 cursor-pointer"
        aria-label="上一页"
      >
        <i className="ri-arrow-left-s-line"></i>
      </button>
      {pages.map((item) => (
        <button
          key={item}
          type="button"
          onClick={() => onChange(item)}
          className={
            item === page
              ? "w-9 h-9 rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 font-label cursor-pointer"
              : "w-9 h-9 rounded-md border border-background-300 text-foreground-700 hover:bg-background-100 font-label cursor-pointer"
          }
          aria-current={item === page ? "page" : undefined}
        >
          {item}
        </button>
      ))}
      <button
        type="button"
        onClick={() => onChange(Math.min(totalPages, page + 1))}
        disabled={page === totalPages}
        className="w-9 h-9 flex items-center justify-center rounded-md border border-background-300 text-foreground-700 disabled:opacity-40 disabled:cursor-not-allowed hover:bg-background-100 cursor-pointer"
        aria-label="下一页"
      >
        <i className="ri-arrow-right-s-line"></i>
      </button>
    </nav>
  );
}